import * as amplitude from '@amplitude/analytics-browser';

// Initialise once, as early as possible
amplitude.init("8ecbc27236eac4f5276a154140982e9b", {
  autocapture: { elementInteractions: true },       // clicks, form inputs, etc.
  defaultTracking: { pageViews: true, sessions: true },  // track basics automatically
});

// Dual-write: send events to both Amplitude and our own backend.
// Backend events power Jordan (product analyst AI) without needing
// Amplitude's paid API. Fire-and-forget — never blocks the UI.
const _origTrack = amplitude.track.bind(amplitude);

amplitude.track = (eventName, properties) => {
  // Always send to Amplitude first
  _origTrack(eventName, properties);

  // Also send to our backend (fire-and-forget)
  try {
    const token = localStorage.getItem('token');
    const endpoint = token
      ? '/mlapi/basic/analytics/event'    // authenticated
      : '/mlapi/analytics/event';          // anonymous (landing page, signup funnel)
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    fetch(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        event_type: eventName,
        properties: properties || {}
      }),
    }).catch(() => {}); // silently ignore backend failures
  } catch {
    // never let analytics break the app
  }
};

export default amplitude;
